export default __webpack_public_path__ + "static/media/hero-image.302d9157.png";